import { getRequestGateway } from '@/services/api.service'
import { AxiosError } from 'axios'

export interface ActCategory {
  id: string
  realmId: string
  name: string
  types: ActReference[]
  statuses: ActReference[]
  createdDate: string
  lastModifiedDate: string
}

type ActReference = {
  id: string
  name: string
}

/*
data class CreateActCategory(
    val name: String,
    val types: List<String>,
    val statuses: List<String>
)
data class UpdateActCategory(
    val name: String,
)
data class ActReferencesDto(
    val references: List<String>,
)

An ActCategory objects with types and statuses are created in file-service database. They are saved on realm level, no duplicates allowed. For testing purpose, a sample is saved for dbproperties dev. User (or IM) should be able to save those categories as wished, delete them and update.
Endpoints:
POST file/acts/categories (@RequestBody: CreateActCategory) = ActCategory
PATCH file/acts/categories/{categoryId} (@RequestBody: UpdateActCategory) = ActCategory
DELETE file/acts/categories/{categoryId} //No response object
PATCH file/acts/categories/{categoryId}/types (@RequestBody: ActReferenceDto) = ActCategory //Add types
DELETE file/acts/categories/{categoryId}/types (@RequestBody: ActReferenceDto) //No response object //Delete statuses
PATCH file/acts/categories/{categoryId}/statuses(@RequestBody: ActReferenceDto) = ActCategory //Add statuses
DELETE file/acts/categories/{categoryId}/statuses(@RequestBody: ActReferenceDto) //No response object
*/

// Get all act categories for realm
export async function getActCategories(): Promise<ActCategory[] | undefined> {
  const endpoint = `${process.env.VUE_APP_API_GW_BASE_URL}/file/acts/categories`
  try {
    const response = await getRequestGateway<ActCategory[]>(endpoint)
    return response?.data
  } catch (error: any) {
    return checkErrorCode(error)
  }
}

// Get act category by id
export async function getActCategoryById(categoryId: string): Promise<ActCategory | undefined> {
  const endpoint = `${process.env.VUE_APP_API_GW_BASE_URL}/file/acts/categories/${categoryId}`
  try {
    const response = await getRequestGateway<ActCategory>(endpoint)
    return response?.data
  } catch (error: any) {
    return checkErrorCode(error)
  }
}

function checkErrorCode(error: AxiosError) {
  if (error.response?.status.toString().startsWith('5')) {
    throw error
  }
  return undefined
}
